import { Typography } from '@mui/material'

import FullScreenModal from '../../../components/full-screen-modal'

const ModalContent = () => {
  return (
    <Typography variant="body1">
      This alert was responded to, but the issue may not be resolved yet. It will remain visible until the device stops detecting the underlying condition.
    </Typography>
  )
}

const ChipInfoDrawer = ({ open, setOpen }: { open: boolean; setOpen: (open: boolean) => void }) => {
  return (
    <FullScreenModal
      open={open}
      onClose={() => setOpen(false)}
      title="Why am I seeing this?"
      showCloseIcon={true}
      confirmLabel="Okay, got it"
      onConfirm={() => setOpen(false)}
      isFullScreen={false}
    >
      <ModalContent />
    </FullScreenModal>
  )
}

export default ChipInfoDrawer
